import React from 'react';
import './MainApp.css';
import { Outlet, useNavigate } from 'react-router-dom';

function MainApp() {
  const navigate = useNavigate();

  return (
    <div className="main-app">
      <aside className="sidebar">
      <div className="sidebar-logo-container">
          <img src='images/skx_logo.png' alt="Company Logo" className="sidebar-logo" />
        </div>
        <h2 className="sidebar-title">Sankalvax Nexus</h2>
        <nav>
          <ul>
            <li onClick={() => navigate('/')}>Dashboard</li>
            {/* <li onClick={() => navigate('/authentications')}>Authentications</li>
            <li onClick={() => navigate('/applications')}>Applications</li>
            <li onClick={() => navigate('/triggers')}>Triggers</li>
            <li onClick={() => navigate('/bank-agent')}>Bank Agent</li>
            <li onClick={() => navigate('/quote-agent')}>Quote Agent</li> */}
          </ul>
        </nav>
      </aside>

      <main className="content-area">
        <Outlet /> {/* ✅ this is what renders the child route */}
      </main>
    </div>
  );
}

export default MainApp;
